import { IncomingMessage } from 'http';
import nookies from 'nookies';
import { v4 as uuid } from 'uuid';

import { getClientIp } from '@/server/utils/getClientIp';
import { getBrowserLanguageFromHeaders } from '@/utils/getBrowserLanguageFromHeaders';
import { redactDigitalJournalQuery } from '@/utils/sensitivePaths';

import { getCookie, setCookie } from '../cookies';
import { getUserToken } from './getUserTokenFromRequest';
import { RequestUserData } from './types';

export function getUserData({
	req,
	deviceId,
	calmUserToken,
	platform,
}: {
	req?: IncomingMessage;
	deviceId?: string;
	calmUserToken?: string;
	platform?: 'www' | 'msft-teams';
} = {}): RequestUserData {
	if (req) {
		const cookies = nookies.get({ req });
		const userToken = getUserToken(cookies, req, calmUserToken);
		const userIp = getClientIp(req);
		const browserLanguage = getBrowserLanguageFromHeaders(req.headers);
		const pathname = typeof req.url === 'string' ? new URL(req.url, 'http://localhost').pathname : undefined;

		return {
			deviceId,
			userToken,
			userIp,
			browserLanguage,
			platform,
			cookies,
			path: pathname,
		};
	}

	const deviceIdCookieValue = getCookie('x-device-id');
	const userToken = getCookie('calm-user-token');
	const newDeviceId = deviceIdCookieValue || uuid();
	if (newDeviceId !== deviceIdCookieValue) {
		setCookie('x-device-id', newDeviceId);
	}

	const href = window?.location?.href;

	return {
		deviceId: newDeviceId,
		userToken,
		// Sent as x-www-req-from on every request, which the API logs, so the journal resend token
		// in this page's query must not ride along.
		path: href && redactDigitalJournalQuery(href),
		cookies: undefined,
	};
}
